import React, { useEffect, useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { messageError, messageToast } from '../../utils/define';
import { linhVucGetItemAction, editLinhVucAction } from '../../store/reducers/linhvuc';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';

const schema = yup.object().shape({
    name: yup.string().required(messageError.emptyMessage)
});

const LinhVucEdit = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const linhVucItem = useSelector((state) => state.linhvuc.linhVucItem);

    const [isLoading, setIsLoading] = useState(false);
    const [idLinhVuc, setIdLinhVuc] = useState('');

    // Lấy id từ URL ?id=xxx
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('id');
        if (id) {
            setIdLinhVuc(id);
            dispatch(linhVucGetItemAction(id));
        }
    }, [dispatch, location.search]);

    const handleEdit = async (values) => {
        const modelUpdate = { data: values, id: idLinhVuc };

        try {
            const result = await dispatch(editLinhVucAction(modelUpdate));
            if (result.payload !== 200) {
                toast.error(messageToast.messageToastUpdateError);
            } else {
                setIsLoading(true);
                toast.success(messageToast.messageToastUpdateSuccess);
                history.goBack();
            }
        } catch (error) {
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        }
    };

    return (
        <Card>
            <Card.Header as="h5">Sửa lĩnh vực</Card.Header>
            <Card.Body>
                {linhVucItem == null ? (
                    <div>Lĩnh vực không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            name: linhVucItem?.name || ''
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>

                                {/* Tên lĩnh vực */}
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">Tên lĩnh vực *</Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Tên lĩnh vực"
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                {/* Buttons */}
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup>
                                            <Button type="submit" theme="primary" disabled={isLoading}>
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button onClick={() => history.goBack()} theme="secondary">
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>

                            </Form>
                        )}
                    </Formik>
                )}

                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default LinhVucEdit;
